"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _notistack = require("notistack");

var _reactRouterDom = require("react-router-dom");

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _loading = _interopRequireDefault(require("../../_common/loading"));

var _item = _interopRequireDefault(require("./item"));

var _detailsNew = _interopRequireDefault(require("./detailsNew"));

var _report = _interopRequireDefault(require("./report"));

var _fullScreen = _interopRequireDefault(require("../../_common/dialog/fullScreen"));

var _orgSelect = _interopRequireDefault(require("../orgSelect"));

var _locationManager = require("../../../redux/locationManager");

var _actions = require("../../../redux/attributes/actions");

var _selectors = require("../../../redux/locationManager/selectors");

var _selectors2 = require("../../../redux/login/selectors");

var _useOrgLocations = _interopRequireDefault(require("../hooks/useOrgLocations"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PAGE_SIZE = 10;

var LocationManager = function LocationManager() {
  var _useState = (0, _react.useState)(PAGE_SIZE),
      _useState2 = _slicedToArray(_useState, 2),
      numRecords = _useState2[0],
      setNumRecords = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      email = _useLoginSelector.claims.email,
      orgIds = _useLoginSelector.orgIds,
      numOrgIds = _useLoginSelector.numOrgIds;

  var _useState5 = (0, _react.useState)(orgIds && orgIds.length ? orgIds[0] : ""),
      _useState6 = _slicedToArray(_useState5, 2),
      orgId = _useState6[0],
      setOrgId = _useState6[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useLocationListSelec = (0, _selectors.useLocationListSelector)(),
      loading = _useLocationListSelec.loading;

  var history = (0, _reactRouterDom.useHistory)();

  var _useParams = (0, _reactRouterDom.useParams)(),
      locationId = _useParams.locationId,
      locationAction = _useParams.locationAction;

  var locationList = (0, _useOrgLocations.default)(orgId);
  var numLocations = locationList === null || locationList === void 0 ? void 0 : locationList.length;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadAttributes)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (orgId) {
      dispatch((0, _locationManager.loadUserLocations)([orgId], email, enqueueSnackbar));
    }
  }, [dispatch, orgId]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (orgIds && numOrgIds > 0) {
      setOrgId(orgIds[0]);
    }
  }, [numOrgIds]); // eslint-disable-line react-hooks/exhaustive-deps

  var filteredIds = (0, _react.useMemo)(function () {
    if (locationList) {
      return locationList.filter(function (location) {
        if (search && search.length) {
          var lowerFilter = search.toLowerCase();
          var locationString = JSON.stringify(location).toLowerCase();
          return locationString.indexOf(lowerFilter) > -1;
        }

        return true;
      }).map(function (location) {
        return location.id;
      });
    }

    return null;
  }, [search, loading, numLocations]); // eslint-disable-line react-hooks/exhaustive-deps

  var onShowMoreClick = function onShowMoreClick() {
    return setNumRecords(numRecords + PAGE_SIZE);
  };

  var onClose = function onClose() {
    return history.push('/admin');
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1 overflow-scroll"
  }, loading ? /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 45
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "location-manager-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locations-fab-container"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin/add"
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    color: "secondary",
    "aria-label": "Add",
    onClick: function onClick() {}
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    htmlColor: "#ffffff"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-manager-search-container flex"
  }, orgIds && orgIds.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_orgSelect.default, {
    value: orgId,
    onChange: function onChange(event) {
      return setOrgId(event.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-manager-search-container"
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "search",
    value: search,
    onChange: function onChange(event) {
      return setSearch(event.target.value);
    },
    label: "Search",
    placeholder: "East Side Infusions",
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_Search.default, null)
    },
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", null, filteredIds && filteredIds.length ? filteredIds.slice(0, numRecords).map(function (locationId, index) {
    return /*#__PURE__*/_react.default.createElement(_item.default, {
      locationId: locationId,
      key: "location-item-".concat(locationId)
    });
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "flex center"
  }, "No locations to show.")), filteredIds && filteredIds.length - 1 > numRecords && /*#__PURE__*/_react.default.createElement("div", {
    className: "location-manager-load-more-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    onClick: onShowMoreClick,
    fullWidth: true
  }, "Load More Locations"))), /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    onClose: onClose,
    open: !!locationId && !locationAction
  }, /*#__PURE__*/_react.default.createElement(_detailsNew.default, {
    locationId: locationId,
    orgId: orgId
  })), /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    onClose: onClose,
    open: !!locationId && locationAction === "report"
  }, /*#__PURE__*/_react.default.createElement(_report.default, {
    locationId: locationId
  })));
};

var _default = LocationManager;
exports.default = _default;